import { FetchContactsInCrmRequestTypes } from '../actions/NumContactsInCrmActions';
const NumContactsInCrm = (state = 0, {
  type,
  payload
}) => {
  switch (type) {
    case FetchContactsInCrmRequestTypes.RECEIVE:
      {
        if (payload) {
          const {
            data
          } = payload;
          return data.total;
        }
        return state;
      }
    default:
      return state;
  }
};
export default NumContactsInCrm;